var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMerchanticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.66667 8.66683C8.66667 6.80016 10.1333 5.3335 12 5.3335C13.8667 5.3335 15.3333 6.80016 15.3333 8.66683C15.3333 10.5335 13.8667 12.0002 12 12.0002C10.1333 12.0002 8.66667 10.5335 8.66667 8.66683ZM18 16.6668V18.0002C18 18.4002 17.7333 18.6668 17.3333 18.6668C16.9333 18.6668 16.6667 18.4002 16.6667 18.0002V16.6668C16.6667 15.5335 15.8 14.6668 14.6667 14.6668H9.33333C8.2 14.6668 7.33333 15.5335 7.33333 16.6668V18.0002C7.33333 18.4002 7.06667 18.6668 6.66667 18.6668C6.26667 18.6668 6 18.4002 6 18.0002V16.6668C6 14.8002 7.46667 13.3335 9.33333 13.3335H14.6667C16.5333 13.3335 18 14.8002 18 16.6668ZM12 10.6668C10.8667 10.6668 10 9.80016 10 8.66683C10 7.5335 10.8667 6.66683 12 6.66683C13.1333 6.66683 14 7.5335 14 8.66683C14 9.80016 13.1333 10.6668 12 10.6668Z",
    fill: "#777C80"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8413_2281",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 5,
    width: 12,
    height: 14
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.66667 8.66683C8.66667 6.80016 10.1333 5.3335 12 5.3335C13.8667 5.3335 15.3333 6.80016 15.3333 8.66683C15.3333 10.5335 13.8667 12.0002 12 12.0002C10.1333 12.0002 8.66667 10.5335 8.66667 8.66683ZM18 16.6668V18.0002C18 18.4002 17.7333 18.6668 17.3333 18.6668C16.9333 18.6668 16.6667 18.4002 16.6667 18.0002V16.6668C16.6667 15.5335 15.8 14.6668 14.6667 14.6668H9.33333C8.2 14.6668 7.33333 15.5335 7.33333 16.6668V18.0002C7.33333 18.4002 7.06667 18.6668 6.66667 18.6668C6.26667 18.6668 6 18.4002 6 18.0002V16.6668C6 14.8002 7.46667 13.3335 9.33333 13.3335H14.6667C16.5333 13.3335 18 14.8002 18 16.6668ZM12 10.6668C10.8667 10.6668 10 9.80016 10 8.66683C10 7.5335 10.8667 6.66683 12 6.66683C13.1333 6.66683 14 7.5335 14 8.66683C14 9.80016 13.1333 10.6668 12 10.6668Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8413_2281)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    fill: "#777C80"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMerchanticon);
export default __webpack_public_path__ + "static/media/merchant icon.a1132d6cd393295bbcb4304943b1e44e.svg";
export { ForwardRef as ReactComponent };